<template>
  <div>
    <BarFloating :distance="0">
      <div class="fixed-bar-options" :showButtonClose="true" v-show="totalSelected > 0">
        <div>
          <div class="side-by-side">
            <div class="div-totalSelected side-by-side">
              <span class="title">
                {{ totalSelected }}
              </span>
            </div>
            <Button _key="btnRemoveItem" type="danger" size="small" classIcon="fa-solid fa-trash" tooltip="Remover"
              eventName="removeItemFixedBar" />
          </div>
          <div class="div-remove side-by-side" @click="closedFixedBar()">
            <i class="fa-solid fa-circle-xmark"></i>
          </div>
        </div>
      </div>
    </BarFloating>
  </div>
</template>
<script>


import FixedBar from "@nixweb/nixloc-ui/src/component/layout/FixedBar.vue";
import BarFloating from "@nixweb/nixloc-ui/src/component/layout/BarFloating.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button.vue";
import Dropdown from "@nixweb/nixloc-ui/src/component/forms/Dropdown.vue";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ItemsSupplierOrderFixedBar",
  components: { FixedBar, Button, Alert, Dropdown, BarFloating },
  props: {
    selected: Array,
    rent: Object,
    isOperational: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showFloatingDiv: true,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.checkPosition);
  },
  destroyed() {
    window.removeEventListener('scroll', this.checkPosition);
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
    totalSelected() {
      return this.selected.length;
    },
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "hideModal", "removeLoading"]),
    checkPosition() {
      const currentPosition = window.scrollY;
      const distance = 250;

      if (currentPosition > distance) {
        this.showFloatingDiv = true;
      } else {
        this.showFloatingDiv = false;
      }
    },
    closedFixedBar() {
      this.addEvent({ name: "closedFixedBar" });
    }
  },
  watch: {
    event: {
      handler(event) {
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.fixed-bar-options {
  max-width: 1150px;
}

.div-remove {
  margin-top: -6px;
  float: right;
  margin-right: 20px;
  font-size: 20px;
  cursor: pointer;
  color: darkgray;
}

.div-totalSelected {
  width: 20px;
  margin-left: 10px;
  font-size: 15px;
}



.total-selected {
  font-size: 16px;
}
</style>